(function () {
  function updatePvFloatingUi() {
    var fsb = document.getElementById('fsb_background');
    var barHeight = 0;

    if (fsb) {
      var rect = fsb.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom >= window.innerHeight - 2) {
        barHeight = Math.ceil(rect.height);
      }
    }

    document.documentElement.style.setProperty('--pv-fsb-bar-height', barHeight + 'px');
    document.documentElement.classList.toggle('pv-has-fsb-bar', barHeight > 0);
  }

  updatePvFloatingUi();
  window.addEventListener('load', updatePvFloatingUi);
  window.addEventListener('resize', updatePvFloatingUi);
  window.addEventListener('scroll', updatePvFloatingUi, { passive: true });

  var fsbPollCount = 0;
  var fsbPollTimer = setInterval(function () {
    updatePvFloatingUi();
    fsbPollCount += 1;
    if (fsbPollCount >= 30) {
      clearInterval(fsbPollTimer);
    }
  }, 500);

  new MutationObserver(updatePvFloatingUi).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
})();

(function () {
  function initBenefitsTicker(root) {
    var track = root.querySelector('.icon-items-ticker__track');
    var viewport = root.querySelector('.icon-items-ticker__viewport');
    var slides = track ? track.querySelectorAll('.icon-items-ticker__slide:not(.icon-items-ticker__slide--clone)') : [];

    if (!track || !viewport || slides.length < 2) {
      return;
    }

    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[slides.length - 1].cloneNode(true);

    firstClone.classList.add('icon-items-ticker__slide--clone');
    lastClone.classList.add('icon-items-ticker__slide--clone');
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');

    track.insertBefore(lastClone, slides[0]);
    track.appendChild(firstClone);

    var slideCount = slides.length;
    var index = 1;
    var timer = null;
    var touchStartX = 0;
    var isAnimating = false;

    function setPosition(animate) {
      if (animate) {
        track.classList.remove('is-resetting');
      } else {
        track.classList.add('is-resetting');
      }

      track.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
    }

    function normalizeIndex() {
      if (index === 0) {
        index = slideCount;
        setPosition(false);
      } else if (index === slideCount + 1) {
        index = 1;
        setPosition(false);
      }

      isAnimating = false;
    }

    function goTo(nextIndex) {
      if (isAnimating) {
        return;
      }

      isAnimating = true;
      index = nextIndex;
      setPosition(true);

      window.setTimeout(function () {
        if (isAnimating) {
          normalizeIndex();
        }
      }, 400);
    }

    function advance(step) {
      goTo(index + step);
    }

    function startAutoplay() {
      if (timer) {
        clearInterval(timer);
      }

      timer = setInterval(function () {
        advance(1);
      }, 4000);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    track.addEventListener('transitionend', function (event) {
      if (event.target !== track || event.propertyName !== 'transform') {
        return;
      }

      normalizeIndex();
    });

    setPosition(false);

    requestAnimationFrame(function () {
      track.classList.remove('is-resetting');
    });

    startAutoplay();

    viewport.addEventListener('touchstart', function (event) {
      touchStartX = event.touches[0].clientX;
      stopAutoplay();
    }, { passive: true });

    viewport.addEventListener('touchend', function (event) {
      var diff = event.changedTouches[0].clientX - touchStartX;

      if (Math.abs(diff) > 40) {
        advance(diff < 0 ? 1 : -1);
      }

      startAutoplay();
    }, { passive: true });

    viewport.addEventListener('mouseenter', stopAutoplay);
    viewport.addEventListener('mouseleave', startAutoplay);
  }

  function initAllBenefitsTickers() {
    document.querySelectorAll('[data-pv-benefits-ticker]:not([data-pv-benefits-ticker-single])').forEach(initBenefitsTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBenefitsTickers);
  } else {
    initAllBenefitsTickers();
  }
})();

$(document).ready(function () {
  /**Back to Top **/
  var $backToTop = $('#back-to-top');

  $(window).scroll(function() {
      if ($(this).scrollTop() > 300) {
          $backToTop.fadeIn();
      } else {
          $backToTop.fadeOut();
      }
  });

  $backToTop.click(function() {
      $('html, body').animate({ scrollTop: 0 }, 'smooth');
  });
  
  $('body').on('mouseenter', '.swatch-items a', function() {
    if($(this).find('picture img').data("src").indexOf("no-image") == -1) {
      $(this).parents('.second-img-hover').find('picture:not(.pl-parent) img:not(.no-pl-px)').attr('src', $(this).find('picture img').data("src"));
      $(this).parents('.second-img-hover').find('picture:not(.pl-parent) img:not(.no-pl-px)').attr('srcset', $(this).find('picture img').data("src"));
    }
  });
  
  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: ".slider-nav",
  });
  $(".slider-nav").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".media_slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    dots: true,
    adaptiveHeight: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });

  /* Tab js*/
  $('ul.shopify-tabs > li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $(this).parent().find('li').removeClass('current');
      $('.shopify-tab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    })

   /*custom Accordian*/
  $(".custom_accordian .btnToggle").click(function () {
    $(this).parent(".accordian_item").toggleClass("active");
    $(".custom_accordian .btnToggle").not(this).parent(".accordian_item").removeClass("active");
    $(".custom_accordian .btnToggle").not(this).siblings(".custom_accordian .toggleBlock").slideUp();
    $(this).siblings(".custom_accordian .toggleBlock").slideToggle();
  });

  /*Footer toggle*/
  $(".toggleBtn").click(function () {
    $(".toggleBtn").not(this).siblings(".toggleBlock").slideUp();
    $(this).toggleClass("active");
    $(".toggleBtn").not(this).removeClass("active");
    $(this).siblings(".toggleBlock").slideToggle();
  });

  /*Fancybox Js*/
  if ($.fancybox) {
    $('[data-fancybox="gallery"]').fancybox({
      buttons: [
        "slideShow",
        "zoom",
        "close"
      ],
      loop: false,
    });
  }

});
